import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'

import Pagination from '@components/Pagination'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Box from '@material-ui/core/Box'
import DeleteIcon from '@material-ui/icons/Delete'
import Button from '@material-ui/core/Button'
import Spinner from '@components/spinner'

class ClientProjectsList extends Component {
    static propTypes = {
        clientProjectsStore: PropTypes.object,
        sidebarStore: PropTypes.object,
        modalStore: PropTypes.object,
        clientName: PropTypes.string,
    }

    constructor (props) {
        super(props)

        this.props.clientProjectsStore.loadClientProjects(this.props.clientName)
        extendObservable(this, {
            confirmModalOpen: false,
            project: null
        })
    }

    openAreYouSure = (project) => {
        this.project = project
        this.confirmModalOpen = true
    }

    handleDelete = () => {
        this.props.clientProjectsStore.deleteProject(this.project.id)
        this.project = null
        this.confirmModalOpen = false
    }

    handleCancel = () => {
        this.project = null
        this.confirmModalOpen = false
    }

    render () {
        const {clientProjectsStore} = this.props
        const {
            projects,
            loading,
            perPage,
            page,
            numOfClientProjects, 
            changePage,
            loadClientProjects,
            autocompleteSuggestion,
            autocompleteResults,
            autocomplete,
            filter,
            filterProjects
            } = clientProjectsStore
        
        const outlookClient = {
            id: 0,
            name: "Outlook Extension",
            type: "outlookExtension"
        }
        const fontStyles = {
            fontSize: 14,
            fontFamily: "'Open Sans', sans-serif",
            color: "#33343A"
        }
        const statusStyles = {
            textTransform: 'capitalize'
        }

        const clientStyles = {
            ...fontStyles,
            color: "#3A86BF",
            cursor: 'pointer'
        }

        const headStyles ={
            ...fontStyles, 
            fontWeight: 700
        }

        if (loading) {
            return (
            <div className='feedback'>
                <Spinner />
            </div>
            )
        }

        return (
            <React.Fragment>
                <TableContainer component={Paper} style={{boxShadow: "unset", minHeight: 400}}>
                    <Box style={{display: 'flex'}}>
                        <Autocomplete
                            value={autocompleteSuggestion}
                            id="combo-box-demo"
                            getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                            onInputChange={(e, value) => {
                                clientProjectsStore.autocompleteSuggestion = value
                                autocomplete(value, ['parentAccount'])
                            }}
                            onChange={(e, value) => loadClientProjects(value?.name || '')}
                            options={[outlookClient, ...autocompleteResults]}
                            style={{ width: 300, marginBottom: 30, marginRight: 30 }}
                            renderInput={(params) => <TextField {...params} label="Filter by client" />}
                            />
                        <FormControl 
                            style={{ width: 300, marginTop: 20 }} variant='standard'>
                            <RadioGroup
                                value={filter}
                                onChange={filterProjects} 
                                aria-labelledby='demo-radio-buttons-group-label'
                                name='radio-buttons-group'
                                row>
                                <FormControlLabel value='all' control={<Radio size='small' />} label='All' />
                                <FormControlLabel value='pending' control={<Radio size='small' />} label='Pending' />
                                <FormControlLabel value='draft' control={<Radio size='small' />} label='Draft' />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                    {projects.length ?
                    <div>
                        <Table aria-label="table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={headStyles}>Status</TableCell>
                                    <TableCell style={headStyles}>Project Name</TableCell>
                                    <TableCell style={headStyles}>Client</TableCell>
                                    <TableCell style={headStyles}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {projects.map((project, index) => (
                                    <TableRow key={index}>
                                        <TableCell style={{...fontStyles, ...statusStyles}}>{project.status}</TableCell>
                                        <TableCell>
                                            <span style={clientStyles} onClick={() =>
                                                this.props.modalStore.show({
                                                type: 'PROJECT_FORM',
                                                props: {
                                                    title: 'Set EPL status to Canceled',
                                                    cancelText: 'Cancel',
                                                    okText: 'Create',
                                                    project: project,
                                                    clientProjectsStore: this.props.clientProjectsStore
                                                }
                                                })}>{project.projectName}</span>
                                        </TableCell>
                                        <TableCell>
                                            <span style={clientStyles} onClick={() =>
                                                this.props.sidebarStore.openSidebar({
                                                    template: 'parent-account',
                                                    id: project.platformClientId
                                                })}>{project.clientName}</span>
                                        </TableCell>
                                        <TableCell>
                                            <DeleteIcon className='delete-icon' onClick={() => this.openAreYouSure(project)}/>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table> 
                        </div>
                        :
                        <div className='no-projects'>No {filter === 'all' ? '' : filter} projects.</div>}
                </TableContainer>

                <Pagination
                    total={numOfClientProjects}
                    perPage={perPage}
                    page={page}
                    onChange={changePage}
                />
                {this.confirmModalOpen && 
                <div className='delete-modal'>
                    <div className='delete-wraper'>
                        <p>Are you sure you want to delete <span className='project-name'>{this.project.projectName}</span>?</p>
                        <div className='buttons'>
                        <Button size="large"
                                color="primary"
                                onClick={this.handleCancel}>Cancel</Button>
                        <Button size="large"
                                variant="contained"
                                color="primary"
                                onClick={this.handleDelete}>Delete</Button>
                        </div>
                    </div>
                </div>}
            </React.Fragment>)
    }
}

export default withRouter(inject('clientProjectsStore', 'modalStore', 'sidebarStore')(observer(ClientProjectsList)))
